import { Avatar, Card, Col, Modal, Row, Typography } from "antd";
import { DoctorsDTO } from "../../models/Doctors";
import { UserOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

interface DoctorModalProps {
  doctor: DoctorsDTO;
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}
const DoctorModal: React.FC<DoctorModalProps> = ({
  visible,
  doctor,
  onOk,
  onCancel,
}) => {
  return (
    <Modal
      title="Profilo Dottore"
      open={visible}
      onOk={() => onOk()}
      onCancel={() => onCancel()}
      width={700}
      footer={null}
    >
      {doctor && (
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <Avatar size={128} icon={<UserOutlined />} />
            </Col>
            <Col span={18}>
              <Title level={4}>
                Dott. {`${doctor.user?.firstName} ${doctor.user?.lastName}`}
              </Title>
              <Paragraph>
                <strong>Specialità:</strong> {doctor.specialty}
              </Paragraph>
              <Paragraph>
                <strong>Email:</strong> {doctor.email}
              </Paragraph>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: "20px" }}>
            <Col span={12}>
              <Paragraph>
                <strong>Data di nascita:</strong> {doctor.birthDate}
              </Paragraph>
              <Paragraph>
                <strong>Genere:</strong> {doctor.gender}
              </Paragraph>
              <Paragraph>
                <strong>Codice Fiscale:</strong> {doctor.taxIdCode}
              </Paragraph>
              <Paragraph>
                <strong>Telefono:</strong> {doctor.phone}
              </Paragraph>
            </Col>
            <Col span={12}>
              <Paragraph>
                <strong>Indirizzo:</strong> {doctor.street}, {doctor.city},{" "}
                {doctor.province} {doctor.postalCode}
              </Paragraph>
              <Paragraph>
                <strong>Nazionalità:</strong> {doctor.nationality}
              </Paragraph>
              <Paragraph>
                <strong>Cittadinanza:</strong> {doctor.citizenship}
              </Paragraph>
            </Col>
          </Row>
        </Card>
      )}
    </Modal>
  );
};

export default DoctorModal;
